import channelsRequest from './channelsRequest';
import lineupRequest from './lineupRequest';
import { Observable } from 'rxjs';
import { IChannelObservable } from '../../types/interfaces/channel';

export default function channelObservable(resetLineup = false) {
  return new Observable<IChannelObservable>((subscriber) => {
    // 1. Reset channels
    subscriber.next({
      hiddenChannels: [],
      visibleChannels: [],
      unavailableChannels: [],
    });
    // 2. Fetch lineup and channels
    new Promise(
      // 2.1 Fetch lineup
      (resolve) => {
        if (resetLineup) {
          lineupRequest().then(() => {
            resolve(true);
          });
        } else {
          resolve(false);
        }
      }
    )
      // 2.2 Fetch channels
      .finally(() => {
        channelsRequest()
          // Receive data from request and send it to subscriber
          .then(({ availableChannels, unavailableChannels }) => {
            subscriber.next({ ...availableChannels, unavailableChannels });
            subscriber.complete();
          })
          // Otherwise, send error to subscriber
          .catch((e) => {
            console.error(e);
            subscriber.error();
            subscriber.complete();
          });
      });
  });
}
